export enum EasyBuilderCampaignType {
  IG_CGT_REPLY = 'easy_generator',
  IG_CGT_REPLY_OPTIONAL_DM = 'easy_builder_cgt',
  IG_CGT_NEXT_POST = 'easy_builder_cgt_next_post',
  IG_CGT_NEXT_POST_MULTI_LINKS = 'easy_builder_cgt_next_post_multi_links',
  IG_CGT_GROW_FOLLOWERS = 'easy_builder_cgt_grow_followers',
  IG_CGT_PRODUCT_GALLERY = 'easy_builder_product_gallery',
  IG_DM_MULTI_LINKS = 'easy_builder_dm_multi_links',
  IG_STORY_REPLY = 'easy_builder_story_reply',
  IG_STORY_REPLY_MULTI_LINKS = 'easy_builder_story_reply_multi_links',
  IG_DIRECT_MESSAGE = 'easy_builder_dm',
}
